import { prefixRoutes } from '@md/routing';
import Receive from './Receive';

export const receiveRoute = (resource, children, component = Receive, type = '(\\d+)') => prefixRoutes(`:id${type}/`, children, { component, props: { resource } });
